<template>
	<div class="page-admins">
		<PartUserTabs/>

		<div class="admin__wrap">
			<h2 class="section-title admin__title">List of all deleted admins</h2>

			<router-link class="btn btn--icon admin__btn" id="back_admin-button" :to="{ name: 'Admins' }">
				<SvgIcon class="admin__btn-icon" iconName="ico-arrow-l"/>
                <span>Back</span>
			</router-link>
			<div class="notification-wrap-side notification-wrap-side--center">
				<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
			</div>
		</div>

		<div class="table-wrap" :class="{'table-empty': noResults}">
			<BlockTable
				v-if="!noResults"
				:data="AdminsTableData"
				class="dashborad-properies-table"
				@deleteRow="deleteRow"
				@restoreRow="restoreRow"
				@sortData="sortAdmins"
				:sort="localOrderBy"
			/>
			<PartLoaderBig class="loader-table" v-if="preloader"/>
			<PartNoResults :data="DataNoResults" v-if="noResults && !preloader"/>
			<PartPagination
				ref="pagination"
				v-show="!preloader && showPagination"
				@getPage="getPage"
			/>
		</div>

		<PartPopupDelete
			v-if="showPopupDelete"
			:data="PopupDelete"
			@confirmPopupDelete="confirmPopupDelete"
			@closePopupDelete="closePopupDelete"
		>
			<template v-slot:popupTitle>Are you sure you want to permanently delete this admin?</template>
			<template v-slot:popupCancel>No</template>
			<template v-slot:popupConfirm>Yes</template>
		</PartPopupDelete>
	</div>
</template>
<script>
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartUserTabs from '@/components/parts/PartUserTabs';
import BlockTable from '@/components/blocks/BlockTable';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNotifications from '@/components/parts/PartNotifications';
import PartPagination from '@/components/parts/PartPagination';
import PartNoResults from '@/components/parts/PartNoResults';

export default {
	data: () => {
		return {
			DataNoResults: {},
			noResults: true,
			notificationsData: {
				type: '',
				msg: ''
			},
			showPagination: false,
			localOrder: 'asc',
			localOrderBy: 'first_name',
			preloader: true,
			PopupDelete: {
				itemID: ''
			},
			showPopupDelete: false,
			AdminsTableData: {
				stickyHeader: true,
				noLocalSorting: true,
				noCollapse: false,
				fields: [
					{ key: 'first_name', label: 'First Name', sortable: true, stickyColumn: true, variant: 'first-name' },
					{ key: 'last_name', label: 'Last Name', sortable: true, stickyColumn: true, variant: 'last-name' },
					{ key: 'email', label: 'Email', sortable: true, stickyColumn: true, variant: 'email' },
					{ key: 'landline_phone', label: 'Landline Phone', sortable: true, stickyColumn: true, variant: 'landline-phone' },
					{ key: 'phone_ext', label: 'Phone Ext', sortable: true, stickyColumn: true, variant: 'phone-ext' },
					{ key: 'cellphone', label: 'Cellphone', sortable: true, stickyColumn: true, variant: 'cellphone' },
					{ key: 'created_at', label: 'Created', sortable: true, stickyColumn: true, variant: 'created-at' },
					{ key: 'delete_admin', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon second-icon-fixed table-fixed-icon--red last-icon-fixed' },
					{ key: 'restore', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed' }
				],
				items: []
			}
		};
	},
	created() {
		this.$store.dispatch('fetchDeletedAdmins').then(response => {
			this.$refs.pagination.updateDataPag(response.data);
			this.checkPagination(response.data);
		});
	},
	components: {
		PartPopupDelete,
		BlockTable,
		PartUserTabs,
		PartLoaderBig,
		PartNoResults,
		SvgIcon,
		PartNotifications,
		PartPagination
	},
	computed: {
		admins() {
			return this.$store.getters.getDeletedAdmins;
		}
	},
	watch: {
		admins() {
			this.noResults = !this.admins.length;
			this.preloader = false;
			this.AdminsTableData.items = this.admins;
		}
	},
	methods: {
		restoreAdmin(id) {
			this.$store.dispatch('restoreAdmin', id).then(response => {
				this.$store.dispatch('fetchDeletedAdmins');
				this.notification(response);
			});
		},
		destroyAdmin(id) {
			this.$store.dispatch('destroyAdmin', id).then(response => {
				this.$store.dispatch('fetchDeletedAdmins');
				if (undefined !== response.data.message) {
					this.notification(response);
				}
			});
		},
		notification(response) {
			this.notificationsData.msg = response.data.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		deleteRow(id) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = id;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		restoreRow(id) {
			this.restoreAdmin(id);
		},
		closePopupDelete() {
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		confirmPopupDelete(id) {
			this.destroyAdmin(id);
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		fetchNewDeletedAdmins(obj) {
			setTimeout(() => {
				this.preloader = true;
			}, 100);

			return this.$store.dispatch('fetchNewDeletedAdmins', obj);
		},
		sortAdmins(item) {
			const obj = {
				order_by: item,
				order: this.SortOrder(item),
				page: 1
			};
			this.localOrderBy = item;
			this.fetchNewDeletedAdmins(obj).then(response => {
				this.$refs.pagination.updateDataPag(response.data);
			});
		},
		SortOrder(item) {
			if (this.localOrderBy === item) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		getPage(page, $ref) {
			const obj = {
				order_by: this.localOrderBy,
				order: this.localOrder,
				page: page
			};
			this.fetchNewDeletedAdmins(obj).then(response => {
				$ref.updateDataPag(response.data);
			});
		},
		checkPagination(data) {
			this.showPagination = data.prev_page_url !== null || data.next_page_url !== null;
		}
	}
};
</script>
<style lang="scss" scoped>
.page-admins {
	padding: 43px 43px 43px 15px;

	@include mq(1200px) {
		max-width: 100%;
		padding: 43px 15px;
	}

	@include mq($xl) {
		padding: 20px 0;
	}
}

.admin__wrap {
	display: flex;
	align-items: center;
	margin-bottom: 20px;

	@include mq($md) {
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	@include mq(400px) {
		flex-direction: column;
		align-items: flex-start;
	}
}

.admin__title {
	margin-right: 25px;
	margin-bottom: 0;
	display: inline-block;
	text-align: left;

		@include mq($md) {
		flex: 0 0 100%;
		max-width: 100%;
		margin-bottom: 15px;
		margin-right: 0;
	}
}

.admins__btn {
	margin-right: 20px;

	&:last-of-type {
		margin-right: 0;
	}

	@include mq(400px) {
		margin-right: 0;
		margin-bottom: 10px;
	}
}
.admin__title {
	margin-right: 25px;

	@include mq($md) {
		margin-right: 0;
	}
}
.admin__btn-icon {
    display: inline-block;
    padding-right: 7px;
    font-size: 11px;
    height: 14px;
}

.table-wrap {
	min-height: 64vh;
}

.notification-wrap-side {
	position: relative;
    left: auto;
    margin-left: 15px;

	@include mq(767px) {
		margin-left: 0;
	}
}
</style>
